var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',{staticClass:"bg"},[_c('poker-table',{attrs:{"name":_vm.displayID},on:{"chat-message":_vm.sendChat}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }